module.exports = __webpack_public_path__ + "img/icon_city1.67c73017.png";